import type { BuildPlaybookBreadcrumbHrefParams } from '../types';

const buildPlaybookBreadcrumbHref = ({
    playbookId,
    versionId,
}: BuildPlaybookBreadcrumbHrefParams): string => {
    if (versionId) {
        return `/admin/playbooks/${encodeURIComponent(playbookId)}/versions/${encodeURIComponent(versionId)}/builder`;
    }

    return `/admin/playbooks/${encodeURIComponent(playbookId)}/builder`;
};

export default buildPlaybookBreadcrumbHref;
